import { ProjectStageEnum } from 'gql/graphql';
import type { BadgePropStatus } from 'uikit';
import { Text } from 'uikit';

import * as React from 'react';

export const stageCellProps: Record<ProjectStageEnum, { label: string; status: BadgePropStatus }> = {
    [ProjectStageEnum.Calculation]: { label: 'Расчет НМЦ', status: 'warning' },
    [ProjectStageEnum.Implementation]: { label: 'Реализация договора', status: 'success' },
};

export const getStageLabel = (stageId: ProjectStageEnum) => stageCellProps[stageId]?.label ?? 'Не указан';

export const ProjectStage = ({ id }: { id: ProjectStageEnum }) => <Text size="s">{getStageLabel(id)}</Text>;

ProjectStage.displayName = 'ProjectStage';
